// Library
import { ClassAttributes, InputHTMLAttributes, useMemo } from 'react';
import { FieldHookConfig, useField } from 'formik';
import { isEmpty } from 'lodash';

import { SelectField } from '../../selectField/SelectField';

// CSS Style for this module
import styles from './selectFieldFormik.module.scss';

interface SelectProps {
	/**
	 * Custom styles of the button
	 */
	customStyles?: string;
	/**
	 * label of the select field
	 */
	label?: string;
	/**
	 * placeholder of the the list
	 */
	placeholder?: string;
	/**
	 * array of data for dropdown
	 */
	data?: string[];
	props: InputHTMLAttributes<HTMLInputElement> &
		ClassAttributes<HTMLInputElement> &
		FieldHookConfig<string>;
	/**
	 * Preset size of the input element. Auto is the default size
	 */
	size?: 'tiny' | 'small' | 'medium' | 'auto';
	/** Element identifier selector for test */
	testId?: string;
	/**
	 * onChange function for keeping track field value
	 * debounce is built in
	 */
	handleChange?: (value: string) => void;
}

/**
 * Select field let users select one of the options from the dropdown list.
 * @param {SelectProps} Prop
 * @returns  a styled select field element
 */
export const SelectFieldFormik = ({
	customStyles,
	label,
	placeholder,
	data,
	size = 'auto',
	testId,
	props,
	handleChange = () => {
		return;
	},
}: SelectProps) => {
	const [field, meta, getFieldHelpers] = useField(props);
	const hasError = useMemo(() => Boolean(meta.error && meta.touched), [meta.error, meta.touched]);

	return (
		<div className={[styles.container, customStyles].join(' ')}>
			{label && <label htmlFor={field.name}>{label}</label>}
			{!props.disabled ? (
				<SelectField
					options={data}
					defaultOption={field.value}
					placeholder={placeholder}
					error={hasError}
					errorMsg={meta.error}
					handleChange={v => {
						getFieldHelpers.setValue(v);
						getFieldHelpers.setTouched(true, false);
						handleChange(v);
					}}
					customStyles={styles[`size-${size}`]}
					height={42}
					testId={testId}
				/>
			) : !isEmpty(field.value) ? (
				<p className={styles.inactive}>{field.value}</p>
			) : (
				<p className={styles.inactive}>&nbsp;</p>
			)}
		</div>
	);
};
